(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/statistics/teammatches/assets/javascripts/models/statteammatches.js') >= 0) return;  svs.modules.push('/components/statistics/teammatches/assets/javascripts/models/statteammatches.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.statistics = svs.statistics || {};
  svs.statistics.models = svs.statistics.models || {};

  svs.statistics.models.StatTeamMatches = Backbone.Model.extend({
    fetchError: false,
    url: function() {
      this.teamId = this.attributes.teamId;
      return [
        svs.core.jupiter.url(),
        '/search/query?ctx=sport_match&type=sport_match&',
        'orfilter=payload.match.homeTeam.id;',
        this.teamId,
        ',payload.match.awayTeam.id;',
        this.teamId
      ]
        .concat(this.urlArguments())
        .join('');
    },
    defaults: function() {
      if ((((svs.statistics || {}).data || {}).teamModels || {}).matches) {
        this.initialize();
        return this.parse(svs.statistics.data.teamModels.matches);
      }
    },
    initialize: function() {
      this.selection = 'range';
      this.fromDate = null;
      this.toDate = null;

      this.matchCollection = this.matchCollection
        ? this.matchCollection
        : new svs.statistics.collections.Matches();
    },
    urlArguments: function() {
      if (this.fromDate) {
        return [
          '&rangefilter=payload.match.startTime;gte;',
          encodeURIComponent(this.fromDate.toJSON()),
          ',payload.match.startTime;lte;',
          encodeURIComponent(this.toDate.toJSON()),
          '&count=100',
          '&sort=payload.match.startTime'
        ];
      }
      return [
        '&rangefilter=payload.match.startTime;gte;now/d-2w',
        '&count=10',
        '&sort=payload.match.startTime'
      ];
    },
    setSelection: function(month) {
      var _self = this;
      if (month !== '0') {
        this.fromDate = moment(month, 'YYYYMM');
        this.toDate = moment(month, 'YYYYMM').add(1, 'M');
      } else {
        this.fromDate = null;
        this.toDate = null;
      }
      this.fetch({
        error: function() {
          _self.matchCollection.reset();
          _self.set('fetchError', true, { silent: true });
          _self.trigger('change', _self);
        }
      });
    },
    parse: function(response) {
      var currentYear = new Date().getFullYear().toString();
      if (response.error !== null) {
        return response;
      }
      this.matchCollection.reset();
      _.each(
        response.result,
        function(obj) {
          var match = obj.payload.match;
          if (_.isObject(match)) {
            match.displayDate =
              match.startTime.substring(0, 4) === currentYear
                ? moment(match.startTime).format('D/M')
                : moment(match.startTime).format('D/M Y');

            if (moment(match.startTime) < moment()) {
              match.media = [];
              match.odds = null;
              match.oddsetDraws = null;
            }

            this.matchCollection.push(match);
          }
        },
        this
      );

      return response;
    }
  });
})(Backbone, _, svs);

 })(window);